<template>
  <el-button
    link
    type="primary"
    @click="handleImport"
  >
    {{ proxy.$t('excel.Import') }}
  </el-button>
  <el-dialog
    v-model="upload.open"
    :title="proxy.$t('excel.Import')"
    width="500px"
    append-to-body
  >
    <el-upload
      ref="uploadRef"
      :limit="1"
      accept=".xlsx, .xls"
      :headers="upload.headers"
      :disabled="upload.isUploading"
      :auto-upload="false"
      :on-change="handleFileChange"
      :on-remove="handleFileRemove"
      drag
      action="#"
    >
      <!-- 注意：action="#" 是为了防止报错，实际走手动逻辑 -->
      <el-icon class="el-icon--upload">
        <UploadFilled />
      </el-icon>
      <div class="el-upload__text">
        {{ proxy.$t('excel.cilckPushTip') }}<em style="color: var(--color-1)">{{ proxy.$t('excel.cilckPush') }}</em>
      </div>

      <template #tip>
        <div class="text-center el-upload__tip">
          <!-- <div class="el-upload__tip"><el-checkbox v-model="upload.updateSupport" />是否更新已经存在的用户数据</div> -->
          {{ proxy.$t('excel.typew') }}
        </div>
      </template>
    </el-upload>

    <template #footer>
      <div class="dialog-footer">
        <!-- 添加 loading 状态 -->
        <el-button
          type="primary"
          :loading="upload.isUploading"
          @click="submitFileForm"
        >
          检验模版
        </el-button>
        <el-button @click="upload.open = false">
          取 消
        </el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog
    v-model="preOpen"
    :title="proxy.$t('excel.Import')"
    width="450px"
    append-to-body
  >
    <div class="PreCenter">
      <el-icon
        v-if="successCount > 0 && failCount > 0"
        :size="24"
        color="#ffa200"
      >
        <WarningFilled />
      </el-icon>

      <el-icon
        v-else-if="failCount > 0"
        :size="24"
        color="#e1291e"
      >
        <CircleCloseFilled />
      </el-icon>
      <el-icon
        v-else
        :size="26"
        color="#00c261"
      >
        <SuccessFilled />
      </el-icon>

      <div class="pretip">
        {{ successCount > 0 && failCount > 0 ? proxy.$t('excel.sFail') : successCount > 0 ? proxy.$t('excel.success') : proxy.$t('excel.fail') }}
      </div>
      <div class="perfill">
        <span class="peritem">{{ proxy.$t('excel.success') }}:<span class="successCount">{{ successCount }}</span></span>
        <span
          v-show="failCount > 0"
          class="peritem"
        >{{ proxy.$t('excel.fail') }}:<span class="failCount">{{ failCount }}</span></span>
        <span
          v-show="failCount > 0"
          class="peritem active"
          @click="failDetail"
        >{{ proxy.$t('excel.failDetail') }}</span>
        <span
          v-show="failCount == 0"
          class="peritem"
        >{{ proxy.$t('excel.successtip') }}</span>
      </div>
      <div
        v-show="failCount > 0"
        class="perfill"
        style="margin-top: 10px"
      >
        {{ proxy.$t('excel.tip') }}
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <!-- 添加 loading 状态 -->
        <el-button
          link
          @click="preOpen = false"
        >
          取 消
        </el-button>
        <el-button
          v-show="failCount == 0"
          type="primary"
          link
          :loading="upload.isUploading"
          @click="submitFile"
        >
          {{
            proxy.$t('excel.Import')
          }}
        </el-button>
        <el-button
          v-if="successCount > 0 && failCount > 0"
          type="primary"
          link
          @click="submitFile"
        >
          {{ proxy.$t('excel.failImport') }}
        </el-button>
      </div>
    </template>
    <el-drawer
      v-model="drawer"
      :with-header="false"
    >
      <div class="title">
        导入失败数据({{ errorList.length }}) <el-icon
          class="icon"
          @click="drawer = false"
        >
          <Close />
        </el-icon>
      </div>

      <div class="errorList">
        <div
          v-for="(item, index) in errorList"
          :key="`${item.name || 'error'}-${index}`"
          class="item"
        >
          <span class="li" />
          {{ item.name }}:{{ item.failReason }}
        </div>
      </div>
    </el-drawer>
  </el-dialog>
</template>
<script setup lang="ts">
import { CircleCloseFilled, Close, SuccessFilled, UploadFilled, WarningFilled } from '@element-plus/icons-vue';
import { getCurrentInstance, reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import request, { globalHeaders } from '../../utils/request.ts';

const { proxy } = getCurrentInstance();
const uploadRef = ref(null);
const currentFile = ref(null); // 用于暂存选择的文件
const successCount = ref(0);
const failCount = ref(0);
const errorList = ref([]);
const drawer = ref(false);

const props = defineProps({
  api: { type: String, default: '' },
  preApi: { type: String, default: '' },
});
const preOpen = ref(false);

const upload = reactive({
  open: false,
  title: '用户导入',
  isUploading: false,
  updateSupport: false,
  headers: globalHeaders(),
  baseUrl: import.meta.env.VITE_APP_BASE_API,
});

/** 文件状态改变时（选择文件后） */
const handleFileChange = (file) => {
  currentFile.value = file.raw; // 获取原生 File 对象
};

/** 移除文件 */
const handleFileRemove = () => {
  currentFile.value = null;
};
const failDetail = () => {
  drawer.value = true;
};

/** 导入按钮操作 */
const handleImport = () => {
  upload.open = true;
  currentFile.value = null;
  if (uploadRef.value) uploadRef.value.clearFiles();
};

/** 校验 */
async function submitFileForm() {
  if (!currentFile.value) {
    ElMessage.error('请先选择文件');
    return;
  }

  const formData = new FormData();
  formData.append('file', currentFile.value);
  try {
    upload.isUploading = true;

    const checkRes = await request({
      url: props.preApi,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    // 假设校验接口返回 code 200 表示通过，或者根据业务逻辑判断
    // 如果校验不通过，后端通常会返回错误信息
    if (checkRes.code == 200) {
      failCount.value = checkRes.data.failCount;
      successCount.value = checkRes.data.successCount;
      errorList.value = checkRes.data.errorList;
      preOpen.value = true;
    }
    // --- 第二步：校验成功后，询问或直接调用正式导入接口 ---
    // 如果校验接口返回了一些提示信息，可以用 ElMessageBox 提示用户
    // await ElMessageBox.confirm('数据校验通过，是否确认导入？', '提示', {
    //   confirmButtonText: '确定导入',
    //   cancelButtonText: '取消',
    //   type: 'success'
    // });

    // // 调用正式导入接口
  } catch (error) {
    // 统一处理错误（校验失败或用户点击取消）
    if (error !== 'cancel') {
      ElMessage.error(error.message || '上传失败');
    }
  } finally {
    upload.isUploading = false;
  }
}
// 上传
async function submitFile() {
  const formData = new FormData();
  formData.append('file', currentFile.value);
  // 如果有其他参数，比如 updateSupport，也可以在这里添加
  // formData.append("updateSupport", upload.updateSupport);
  try {
    upload.isUploading = true;

    const importRes = await request({
      url: props.api, // 使用传入的 props.api
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    if (importRes.code === 200) {
      upload.isUploading = false;
      preOpen.value = false;
      ElMessage.success('导入成功');
      upload.open = false;
      // 触发父组件刷新数据
      proxy.$emit('callback');
    }
  } catch (error) {
    upload.isUploading = false;
    if (error !== 'cancel') {
      ElMessage.error(error.message || '上传失败');
    }
  } finally {
    upload.isUploading = false;
  }
}
</script>
<style lang="scss" scoped>
.PreCenter {
  text-align: center;
  .pretip {
    color: #333;
    font-size: 16px;
    margin: 10px 0;
  }
  .perfill {
    font-size: 12px;
    color: #afadad;
    .peritem {
      margin-inline-end: 10px;
      &.active {
        color: var(--color-1);
        cursor: pointer;
      }
      .successCount {
        color: #00c261;
      }
      .failCount {
        color: #e1291e;
      }
    }
  }
}
.title {
  height: 30px;
  border-bottom: 1px #eeeeee solid;
  font-weight: 600;
  position: relative;
  .icon {
    position: absolute;
    inset-inline-end: 10px;
    font-size: 20px;
  }
}
.errorList {
  height: calc(100vh - 66px);
  overflow-y: auto;
  padding: 10px 0;
  .item {
    margin-bottom: 10px;

    .li {
      display: inline-block;
      width: 4px;
      height: 4px;
      background: rgb(185, 183, 183);
      border-radius: 2px;
    }
  }
}
</style>
